export default __webpack_public_path__ + "static/media/login-bg.4aba0a31.jpg";